import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BlackCTA() {
    return (
        <section
            id="cta-final"
            data-testid="black-cta-section"
            className="bg-[#1A1A1A] py-32 md:py-48"
        >
            <div className="max-w-[1000px] mx-auto px-6 md:px-12 text-center">
                <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#F4F1EA] leading-[1.05]">
                    Una conversación de treinta minutos.
                </h2>
                <h2 className="font-serif-display italic text-4xl md:text-6xl tracking-tight text-[#8B6914] leading-[1.05] mt-3">
                    Puede cambiar el resto de tu año.
                </h2>

                <p className="mt-10 text-base md:text-lg text-[#A4A19A] leading-[1.75] max-w-[720px] mx-auto">
                    Te preguntamos cómo vendes hoy. Te decimos si encajamos. Si encajamos, te
                    explicamos cómo. Si no encajamos, te lo decimos — y te recomendamos por dónde sí.
                </p>

                <p className="mt-8 font-serif-display italic text-lg md:text-xl text-[#F4F1EA]">
                    Sin pitch. Sin compromiso. Sin pérdida de tiempo.
                </p>

                <Link
                    to="/contacto"
                    data-testid="black-cta-button"
                    className="mt-12 inline-flex items-center justify-center gap-3 px-9 py-5 bg-[#8B6914] text-white text-sm tracking-wide hover:bg-[#A47F1E] transition-colors duration-200"
                >
                    Reserva tu llamada de descubrimiento
                    <ArrowRight size={16} />
                </Link>
            </div>
        </section>
    );
}
